import type { ComponentType } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import LineBedSofaIcon from 'LuxKit/Icons/line/LineBedSofaIcon'
import LineGlassMartiniAltIcon from 'LuxKit/Icons/line/LineGlassMartiniAltIcon'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineSunsetIcon from 'LuxKit/Icons/line/LineSunsetIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineUtensilsIcon from 'LuxKit/Icons/line/LineUtensilsIcon'
import LineWaterIcon from 'LuxKit/Icons/line/LineWaterIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { type OfferPageHighlightTag, type OfferPageHighlightTagIcon } from './useOfferPageHighlightTags'

const IconContainer = styled.div`
  align-items: center;
  background-color: ${props => props.theme.palette.neutral.default.six};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: ${rem(40)};
  justify-content: center;
  width: ${rem(40)};
`

const highlightTagIcons: Record<OfferPageHighlightTagIcon, ComponentType> = {
  'bed-sofa': LineBedSofaIcon,
  'glass-martini': LineGlassMartiniAltIcon,
  'map-marker': LineMapMarkerIcon,
  restaurant: LineRestaurantIcon,
  star: LineStarIcon,
  sunset: LineSunsetIcon,
  trees: LineTreesIcon,
  utensils: LineUtensilsIcon,
  water: LineWaterIcon,
}

interface Props {
  tag: OfferPageHighlightTag
}

function OfferPageHighlightTagItem(props: Props) {
  const { tag } = props
  const HighlightIcon = highlightTagIcons[tag.icon]

  return <Group direction="horizontal" gap={12} verticalAlign="center">
    <IconContainer><HighlightIcon /></IconContainer>
    <div>
      <Heading variant="heading6">{tag.title}</Heading>
      <BodyText variant="medium" colour="neutral-two">{tag.description}</BodyText>
    </div>
  </Group>
}

export default OfferPageHighlightTagItem
